import React from 'react';
import BilledRecipientShape from 'app/shapes/BilledRecipientShape';

import {
  Grid,
} from '@mui/material';

const BilledRecipient = ({ recipient }) => {
  return (
    <Grid
      container
      direction="row"
    >
      <Grid item xs={6}>
        { recipient.customerId ? (
          <a
            href={`/my_customers/${recipient.customerId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {recipient.login}
          </a>
        ) : (
          <span>{recipient.login}</span>
        )}
      </Grid>
      <Grid item xs={6}>
        {recipient.paid ? 'Paid' : 'Unpaid'}
      </Grid>
    </Grid>
  );
};

BilledRecipient.propTypes = {
  recipient: BilledRecipientShape.isRequired,
};
export default BilledRecipient;
